<template>
<div class="ui large modal" id="PartnerModal"> <!--ui fullscreen modal -->

     <i class="close icon" @click="onClose()" ></i>

 
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <div class="ui form segment">
    <app-header v-if="showMenu" ></app-header>

    <div class="ui attached segment">
       
        <div class="one field">
            <div class="field">
                <label>Party Name</label>
                <div class = "ui input error">
                <input placeholder="Party Name" style="width:400px" name="_partyname" type="text"  ref="ipPartyName" v-on:input="validationMessageRequired" :maxlength="max_500">
            </div>
        </div>
         <div class="one field">
            <div class="field">
                <label>Business Profile</label>
                <div class = "ui input error">
                <input placeholder="Business Profile" style="width:400px" name="_businessprofile" type="text"  ref="ipBusinessProfile" v-on:input="validationMessageRequired" :maxlength="max_500">
            </div>
        </div>
         <div class="one field">
            <div class="field">
                <label>Qualifier</label>
                <select class="ui dropdown"  name="route"  v-model="qualifierSelected" > 
                <option v-for="qualifier in qualifiers" v-bind:value="qualifier.qualifier" v-bind:key="qualifier.qualifier" >
                  {{ qualifier.description }}
                </option>
                </select>
            </div>
        </div>
         <div class="one field">
            <div class="field">
                <label>Identifier</label>
                <div class = "ui input error">
                <input placeholder="Identifier" style="width:400px" name="_identifier" type="text"  ref="ipIdentifier" v-on:input="validationMessageRequired" :maxlength="max_500">
            </div>
        </div>
   
        <br />
       <div class="four fields">
            <div class="field">
              <div class="ui primary submit button" @click="createPartner()">Create Party</div>
                <button class="ui button" @click="resetControls">Reset</button> 
             </div>
      </div>
      <div class="ui negative message" v-if="showMessage">
          <div class="header">
           Please correct the following error(s):
          </div>
          <p>
            {{ message_Enter }}
          </p>
      </div>
      <div class="ui negative message" v-if="showResponseData">
          <p>
            {{ response_Data }}
          </p>
      </div>
      <div class="ui modal">
        <!-- <i class="close icon"></i>  -->
        <div class="header">
            Do you want to continue?
        </div>
        
        <div class="actions">
            <div class="ui black deny button">
            Nope
            </div>
            <div class="ui positive right labeled icon button">
            Yes
            <i class="checkmark icon"></i>
            </div>
        </div>
      </div>
    </div> 

  </div>
</div>
</div>
</div>
</div>
</div>
</template>  


<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'

export default {
components: {
    appHeader: Header
  },
data () {
    return {
      loaded : "1",
      showMenu :false,
      tokenExpired : 0,
      qualifiers :[],
      qualifierSelected : "",
       input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
       message_Enter : "Please enter ",
      showMessage : 0,
      max_30 : 30,
      max_500 :500,
      application_Error : "",
      response_Data : "",
      showResponseData : 0
    }
  },
  methods: {
     bindQualifier(){
        if(localStorage.getItem('id_token')){
         this.loaded = 1; 
         axios({ method: "GET", "url": Vue.prototype.$microservice_url + "getediqualifierlist", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('int_platform_token') 
                } }).then
                (
                    result => {
                    this.qualifiers = result.data;
                    this.qualifierSelected = -1;
                    console.log(this.qualifiers);
                   
                  this.loaded = 2; 
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    },
    
    sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },
  

    checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['RefreshToken'] = localStorage.getItem('int_platform_refresh_token');
     this.input['AcceessToken'] = localStorage.getItem('int_platform_token')
    await axios({ method: "POST", "url": Vue.prototype.$intPlatform_url + "refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
         // localStorage.setItem('id_token', result.data.access_token);
          //localStorage.setItem('refresh_token', result.data.refresh_token);

          localStorage.setItem('int_platform_token', result.data.accessToken);
          localStorage.setItem('int_platform_refresh_token', result.data.refreshToken);
          localStorage.setItem('int_platform_token_expiry_date', result.data.expiresIn);
         }, 
      error => {
          this.refreshToken_Event_Fired = 0;
          console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('int_platform_token_expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    resetControls () {
      this.showResponseData = 0;
      this.showMessage = 0;
      this.$refs.ipPartyName.value = "";
      this.$refs.ipBusinessProfile.value = "";
      this.$refs.ipIdentifier.value = "";
      this.qualifierSelected = -1;
    
      this.checkTokenExpired();
    },
    createPartner(){
      this.showResponseData = 0;
      this.showMessages();
      
      if(this.showMessage == 0){
      swal({
        title: "",
        text: "Are you sure, to create Party?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Create it!",
        closeOnConfirm: true
      },() => {
        
        console.log(this.$refs.ipPartyName.value.trim());
          axios({ method: "POST", "url":  Vue.prototype.$microservice_url +  "createpartner", 
                "data": {
                  PartyName : this.$refs.ipPartyName.value.trim(),
                  BusinessProfile :  this.$refs.ipBusinessProfile.value.trim() ,
                  Identifier : this.$refs.ipIdentifier.value.trim(), 
                  QualifierDescription :  this.qualifiers.filter(x=> x.qualifier === this.qualifierSelected)[0].description,
                  Qualifier : this.qualifierSelected
                }, 
                 "headers": 
                  { 
                    "content-type": "application/json" ,
                    "authorization": "bearer " + localStorage.getItem('int_platform_token') 
                  }  }).then
                (
                  result => {

                  console.log(result.data);
                    
                    this.showResponseData = 1;
                    this.response_Data = result.data;
                    if(result.data == 'This is Partner Controller'){
                       sweetAlert('Party created successfully', '', 'success')
                    }
                    //this.resetControls();
        
                 }, 
                error => {
                console.error(error.response);
                this.application_Error = error.response;
                sweetAlert('Something\'s Wrong!', error, 'error')
                });
        
      })}
    },
    validationMessageRequired(){
      if(this.showMessage == 1){
         this.showMessages();
      }
    },
    onClose(){
      this.resetControls ();
    },
   
    showMessages(){
     this.message_Enter = "Please enter ";
     this.showMessage = 0;

    if(this.$refs.ipPartyName.value.trim() == ""){
    this.message_Enter = this.message_Enter + "Party Name";
     this.showMessage = 1;
    }

     if(this.$refs.ipBusinessProfile.value.trim() == ""){
     this.showMessage = 1;
     if (this.message_Enter != "Please enter ")
     this.message_Enter = this.message_Enter + ',';
     this.message_Enter = this.message_Enter + "Business Profile";
    }

     if(this.$refs.ipIdentifier.value.trim() == ""){
     this.showMessage = 1;
     if (this.message_Enter != "Please enter ")
     this.message_Enter = this.message_Enter + ',';
     this.message_Enter = this.message_Enter + "Identifier";
    }
     if (this.message_Enter == "Please enter "){
      this.message_Enter = "";
      this.showMessage = 0;
    }
  }
   
  },
   created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
      this.bindQualifier();
 
     }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/biztlak-partner-management/CreatePartner.vue